import { useEffect, useState } from "react";
import { CheckCircle2, Loader2, XCircle } from "lucide-react";
import { Link } from "react-router-dom";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function PaymentResult() {
  const [state, setState] = useState("CHECKING");
  const params = new URLSearchParams(window.location.search);
  const txn = params.get("txn");
  const src = ["phonepe", "easebuzz", "cashfree"].includes(params.get("src")) ? params.get("src") : "phonepe";

  useEffect(() => {
    if (!txn) {
      setState("UNKNOWN");
      return;
    }
    let timer;
    let attempts = 0;
    const check = async () => {
      try {
        const r = await fetch(`${API}/payments/${src}/status/${txn}`);
        const x = await r.json();
        const s = x.state || "PENDING";
        setState(s);
        if (s === "PENDING" && attempts++ < 20) timer = setTimeout(check, 4000);
      } catch {
        if (attempts++ < 5) timer = setTimeout(check, 4000);
        else setState("PENDING");
      }
    };
    check();
    return () => clearTimeout(timer);
  }, [txn]);

  const Icon = state === "COMPLETED" ? CheckCircle2 : state === "FAILED" ? XCircle : Loader2;
  const title =
    state === "COMPLETED"
      ? "Payment received — merci!"
      : state === "FAILED"
        ? "Payment failed — nothing was charged."
        : "Checking your payment…";

  return (
    <section data-testid="payment-result-page" className="pt-32 pb-24 lg:pt-40">
      <div className="max-w-xl mx-auto px-6 text-center">
        <Icon
          size={56}
          className={`mx-auto mb-6 ${state === "COMPLETED" ? "text-green-600" : state === "FAILED" ? "text-red-500" : "text-[#C85A32] animate-spin"} ${state === "FAILED" ? "animate-none" : ""}`}
        />
        <h1 className="font-display font-medium text-4xl tracking-tight" data-testid="payment-result-title">
          {title}
        </h1>
        {state === "COMPLETED" && (
          <p className="mt-4 text-[#1C130E]/70">Your order is confirmed — we've sent the details to the maison.</p>
        )}
        {state === "FAILED" && (
          <p className="mt-4 text-[#1C130E]/70">
            You can try again from the{" "}
            <Link to="/#order" className="text-[#C85A32] underline">
              order section
            </Link>{" "}
            or pay cash on delivery.
          </p>
        )}
        {txn && <p className="mt-6 font-mono-accent text-[10px] tracking-[0.2em] uppercase text-[#1C130E]/40">Ref · {txn}</p>}
        <Link
          to="/"
          data-testid="payment-result-home"
          className="mt-10 inline-flex items-center justify-center rounded-full bg-[#1C130E] text-[#FDFBF7] px-8 py-4 text-sm font-semibold hover:bg-[#C85A32] transition-colors"
        >
          Back to home
        </Link>
      </div>
    </section>
  );
}
